import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { memo, useRef, useState, useEffect, useMemo } from "react";
import { pluck, pick, filter, equals, uniq, pipe, map, compose, prop, flatten } from "ramda";
import { Flex, TertiarySmall } from "@base-ui";
import GraphAxisTable from "@dataVisualizations/graphAxisTable/GraphAxisTable";
import StackedBarchartGraph from "./StackedBarchartGraph";
import Legends from "./Legends";
import { GraphContainer } from "./stackedBarchart.styles";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default /*#__PURE__*/memo(function StackedBarchart(props) {
  var id = props.id,
    data = props.data,
    colors = props.colors,
    measureUnit = props.measureUnit,
    style = props.style;
  var layerKeys = useMemo(function () {
    return pipe(map(compose(pluck("partition"), prop("data"))), flatten, filter(Boolean), uniq)(data);
  }, [data]);
  var layers = layerKeys.map(function (key, i) {
    return {
      id: key,
      name: key,
      color: colors[i]
    };
  });
  var _useState = useState(layerKeys),
    _useState2 = _slicedToArray(_useState, 2),
    activeLayers = _useState2[0],
    setActiveLayers = _useState2[1];
  var containerRef = useRef();
  useEffect(function () {
    setActiveLayers(layerKeys);
  }, [layerKeys]);
  var filteredData = data.map(function (entry) {
    return _objectSpread(_objectSpread({}, entry), {}, {
      data: entry.data.filter(function (x) {
        return activeLayers.includes(x.partition);
      })
    });
  });
  var chartData = filteredData.map(function (entry) {
    return _objectSpread(_objectSpread(_objectSpread({}, pick(["id", "name"], entry)), entry.data.reduce(function (acc, curr) {
      if (activeLayers.includes(curr.partition)) acc[curr.partition] = curr.dependent;
      return acc;
    }, {})), {}, {
      total: entry.data.reduce(function (acc, curr) {
        return acc + curr.dependent;
      }, 0)
    });
  });
  return /*#__PURE__*/_jsxs(Flex.Column, {
    style: style,
    children: [/*#__PURE__*/_jsx(Legends, {
      id: id,
      layers: layers,
      activeLayers: activeLayers,
      setActiveLayers: setActiveLayers
    }), /*#__PURE__*/_jsxs(Flex.Row, {
      breakpoint: [2],
      children: [/*#__PURE__*/_jsx(GraphAxisTable, _objectSpread({
        data: filteredData
      }, pick(["columns", "measureUnit", "sort", "sortDirection", "updateSort", "remove", "disableInteraction", "drilldownLabel", "drilldown", "tableCaption", "defaultText"], props))), /*#__PURE__*/_jsxs(GraphContainer, {
        ref: containerRef,
        children: [/*#__PURE__*/_jsxs(TertiarySmall, {
          style: {
            margin: 0,
            textAlign: "right"
          },
          children: ["M\xE5ttenhet: ", measureUnit]
        }), /*#__PURE__*/_jsx(StackedBarchartGraph, _objectSpread(_objectSpread({}, pick(["measureUnit", "colors"], props)), {}, {
          layerKeys: layerKeys,
          activeLayers: activeLayers,
          data: chartData,
          containerRef: containerRef
        }))]
      })]
    })]
  });
}, function (prev, curr) {
  return equals(prev.data, curr.data) && equals(prev.sort, curr.sort) && equals(prev.sortDirection, curr.sortDirection) && equals(prev.disableInteraction, curr.disableInteraction);
});